<template>
    <fieldset>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Miljö</div>
            </div>
            <select
                class="custom-select"
                required
                v-model="environment"
                @change="onUpdate"
            >
                <option value="production">Produktionsmiljö</option>
                <option value="playground">Testmiljö</option>
            </select>
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Api Key</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="apiKey"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Callback Api Key</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="callbackApiKey"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: PaymentId</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldPaymentId"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Manuell infångning</div>
            </div>
            <select
                class="custom-select"
                v-model="manualCapture"
                @change="onUpdate"
                required
            >
                <option :value="false">Nej</option>
                <option :value="true">Ja</option>
            </select>
        </div>
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const environment = ref(null);
const apiKey = ref(null);
const callbackApiKey = ref(null);
const fieldPaymentId = ref(null);
const manualCapture = ref(null);
const serializedValue = computed(() => {
  return {
    environment: environment.value,
    api_key: apiKey.value,
    callback_api_key: callbackApiKey.value,
    field_payment_id: fieldPaymentId.value,
    manual_capture: manualCapture.value
  };
});
function onUpdate() {
    emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    environment.value = modelValue.value.environment;
    apiKey.value = modelValue.value.api_key;
    callbackApiKey.value = modelValue.value.callback_api_key;
    fieldPaymentId.value = modelValue.value.field_payment_id;
    manualCapture.value = modelValue.value.manual_capture;
    if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
      onUpdate();
    }
  }
}, {
  immediate: true
});
</script>
